import { useCallback, useEffect, useState } from 'react'

// There are a few places in the codebase where we want to show a badge briefly in response to
// events, like showing an "Added" badge when an item is added to an estimate or invoice. After
// a short period of time we want the badge to disappear. But if another event occurs before
// the badge has disappeared, we want to reset the timer. This hook manages that state.
export const useTransientEventBadge = (
    { delayMillis }: { delayMillis: number } = { delayMillis: 1000 }
) => {
    const [eventRefCount, setEventRefCount] = useState(0)

    const onEvent = useCallback(() => {
        setEventRefCount((prev) => prev + 1)
    }, [])

    useEffect(() => {
        if (eventRefCount === 0) {
            return
        }

        const timeoutID = setTimeout(() => setEventRefCount(0), delayMillis)
        return () => clearTimeout(timeoutID)
    }, [eventRefCount, delayMillis])

    return { isBadgeShowing: eventRefCount > 0, onEvent }
}
